'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { localizePath } from '@/shared/lib/public-routes';
import { useToast } from '@ncai-axe/react-ui-v3';
import IcAlert from '@ncai-axe/react-ui-v3/assets/svg/icons/ic_alert_circle_fill.svg';
import { useTranslations } from 'next-intl';
import { useParams, usePathname, useRouter } from 'next/navigation';
import { ApiError } from '../instance/error';
import { ErrorHandlerDeps, HandleApiErrorResult, handleApiError } from './handle-api-error';
export function useApiErrorHandler(extraDeps) {
  const $ = _c(7);
  const params = useParams();
  const t = useTranslations("error");
  const router = useRouter();
  const pathname = usePathname();
  const {
    toast
  } = useToast();
  let t0;
  if ($[0] !== extraDeps || $[1] !== params?.locale || $[2] !== pathname || $[3] !== router || $[4] !== t || $[5] !== toast) {
    t0 = error => handleApiError(error, {
      toast: options => toast({
        ...options,
        icon: <IcAlert />
      }),
      redirect: path => {
        const localizedPath = localizePath(path, params?.locale);
        if (pathname === localizedPath) {
          return;
        }
        router.push(localizedPath);
      },
      t,
      ...extraDeps
    });
    $[0] = extraDeps;
    $[1] = params?.locale;
    $[2] = pathname;
    $[3] = router;
    $[4] = t;
    $[5] = toast;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  params?.locale;
  return t0;
}